/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import Icon from "components/common_components/Icon";
import { formatPhoneNumber } from "./utils";
import useMessageVariables from "./useMessageVariables";
import ChatInitializerContext from "./ChatInitializerContext";
import MediaMessage from "./MediaMessage";
import { Dialog, DialogContent } from "@material-ui/core";
import chatUserDirectImg from "assets/images/chat-user-direct.png";

function Message({ message, isSameParticipant }) {
    const { sid, author, body } = message;
    const [mediaDownloadFailed, setMediaDownloadFailed] = useState(false);
    const [mediaUrl, setMediaUrl] = useState(null);
    const { authorLabelResolver, clientPhotoResolver } = useContext(ChatInitializerContext);
    const [mediaDialogProps, setMediaDialogProps] = useState({
        open: false,
        fullScreen: false,
        onClose: () => setMediaDialogProps((prev) => ({ ...prev, open: false })),
    });

    const { isIncomming, hasMedia, isSMS, getDirectionString } = useMessageVariables({
        message,
    });

    useEffect(() => {
        document.getElementById(sid).scrollIntoView({ behavior: "smooth" });
    }, []);

    useEffect(() => {
        if (hasMedia) {
            const getMediaUrlAsync = async () => {
                try {
                    const mediaUrlResponse = await message.media.getContentTemporaryUrl();
                    setMediaUrl(mediaUrlResponse);
                } catch (error) {
                    console.error("The media url couldn't be loaded.", error);
                    setMediaDownloadFailed(true);
                }
            };
            getMediaUrlAsync();
        }
    }, [hasMedia]);

    const handleOnMediaClick = () => {
        setMediaDialogProps((prev) => ({ ...prev, open: true }));
    };

    const getIconName = () => {
        if (isSMS) {
            return "sms";
        }
        return "chat";
    };

    return (
        <div id={sid} className={clsx("message")}>
            {isIncomming && !isSameParticipant && (
                <div
                    className="photo"
                    style={{
                        backgroundImage: `url(${clientPhotoResolver(message.conversation) || chatUserDirectImg})`,
                    }}
                />
            )}

            <div className={clsx(getDirectionString(), { "text-only": isSameParticipant })}>
                <div className="text">
                    <p className="participant">
                        <Icon name={`chat-participant-${getIconName()}`} color="grey" title={getIconName()} />
                        <span className="author" title={isIncomming && isSMS ? formatPhoneNumber(String(author)) : ""}>
                            {authorLabelResolver(message)}
                        </span>
                    </p>
                    {hasMedia && (
                        <div className="medias">
                            {
                                <MediaMessage
                                    hasFailed={mediaDownloadFailed}
                                    url={mediaUrl}
                                    type={message.media.contentType}
                                    onClick={handleOnMediaClick}
                                />
                            }
                        </div>
                    )}
                    <p className="body">{body}</p>
                </div>
                <span className="time">{message.state.timestamp.toLocaleString()}</span>
            </div>
            {hasMedia && (
                <Dialog {...mediaDialogProps}>
                    <DialogContent>
                        {String(message.media.contentType).startsWith("image") && (
                            <div className="picture_preview" style={{ backgroundImage: `url(${mediaUrl})`, zIndex: 122 }} />
                        )}
                    </DialogContent>
                </Dialog>
            )}
        </div>
    );
}

Message.propTypes = {
    message: PropTypes.shape({
        index: PropTypes.number,
        author: PropTypes.string,
        body: PropTypes.string,
        type: PropTypes.string,
    }).isRequired,
};

export default Message;
